import React from "react";
import ReactTooltip from "react-tooltip";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

class ToolTipLinkExternal extends React.Component {
    render() {
        return (
            <FormattedMessage id={this.props.title}>
                {title =>
                    <a href={this.props.href} target="_blank" rel="noopener noreferrer" data-tip data-for={title}>
                        {this.props.children}
                        <ReactTooltip id={title} type="success" effect="solid" className="custom-tooltip">
                            <span>{title}</span>
                        </ReactTooltip>
                    </a>
                }
            </FormattedMessage>
        );
    }
}


ToolTipLinkExternal.propTypes = {
    href: PropTypes.string.isRequired
}
export default ToolTipLinkExternal;